import {
  STANDARD_IDENTIFIER_ALIASES,
  normalizeIdentifierHeader,
} from './standardIdentifierTypes';

export type GroupedIdentifierConstituent = {
  asin?: string;
  seller_sku?: string;
  barcode?: string;
  identifier_type?: string;
  identifier_value?: string;
};

const EMPTY_DISPLAY_VALUES = new Set(['', '-', '—']);

function cleanDisplayValue(value: string | undefined): string | null {
  const trimmed = value?.trim();
  if (!trimmed || EMPTY_DISPLAY_VALUES.has(trimmed)) return null;
  return trimmed;
}

/** Standard types become SKU/ASIN/…; custom names stay as stored. */
export function formatIdentifierTypeLabel(identifierType: string | null | undefined): string {
  const raw = String(identifierType ?? '').trim();
  if (!raw) return 'SKU';
  const standard = STANDARD_IDENTIFIER_ALIASES[normalizeIdentifierHeader(raw)];
  if (standard) return standard.toUpperCase();
  return raw;
}

export function groupedIdentifierLines(
  constituent: GroupedIdentifierConstituent,
): Array<{ type: string; value: string }> {
  const typedValue = cleanDisplayValue(constituent.identifier_value || constituent.seller_sku);
  if (constituent.identifier_type && typedValue) {
    return [{ type: formatIdentifierTypeLabel(constituent.identifier_type), value: typedValue }];
  }

  const lines: Array<{ type: string; value: string }> = [];
  const asin = cleanDisplayValue(constituent.asin);
  const barcode = cleanDisplayValue(constituent.barcode);
  if (asin) lines.push({ type: 'ASIN', value: asin });
  if (barcode) lines.push({ type: 'Barcode', value: barcode });
  const sku = cleanDisplayValue(constituent.seller_sku);
  if (sku) lines.push({ type: 'SKU', value: sku });
  return lines;
}
